import React from 'react';
import { CheckIcon, ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { checkoutUrl, productBrand, productEdition } from '../data/offer';
const assurances = ['7-day guarantee', 'Secure payment', 'Instant access'];
export function FinalCta() {
  return <section className="border-t border-slate-200 bg-slate-50 py-16 sm:py-20" aria-labelledby="final-title" data-id="element-62" data-mp="15ddjbc9f61kl">
      <div className="mx-auto max-w-3xl px-4 text-center" data-id="element-63" data-mp="1jcvc02pu5yz8">
        <h2 id="final-title" className="text-balance text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl" data-id="element-64" data-mp="1jbaj0hj66o3h">
          <span className="inline-flex items-center gap-2" data-id="element-65" data-mp="1ec7k7ets9e3y">
            <ZapIcon className="h-8 w-8 shrink-0 text-amber-600" aria-hidden="true" data-id="element-66" data-mp="1t1n0u1zlo35x" /> {productBrand}
          </span>
          <span className="mt-2 block text-xl font-semibold text-teal-700 sm:text-2xl" data-id="element-67" data-mp="1o4n26c52y2ou">
            {productEdition}
          </span>
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-lg leading-relaxed text-slate-600" data-id="element-68" data-mp="1x51qlkdcbxwk">
          Created for instrumentation, control and automation professionals worldwide.
        </p>

        <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" arrow className="mt-8 w-full sm:w-auto" data-id="element-69" data-mp="s4p9dh3ne077">
          Get my professional edition now
        </Button>

        <ul className="mt-8 flex flex-wrap justify-center gap-x-5 gap-y-2 text-sm text-slate-600" data-id="element-70" data-mp="x5v7xvjzohon">
          {assurances.map(item => <li key={item} className="inline-flex items-center gap-1.5" data-id="element-71" data-mp="164qc723h3hpb">
              <CheckIcon className="h-4 w-4 text-teal-700" aria-hidden="true" data-id="element-72" data-mp="162dxcxt0hngh" /> {item}
            </li>)}
        </ul>
      </div>
    </section>;
}